import { DataSecurityIncident } from '@types';

import { createGetEndpoint, getQueryString } from '@sonar-software/sonar-http';
import { DynamicQueryParams, KeyPaginationQueryParams, PaginatedResource } from '@sonar-software/sonar-ts-types';

export type GetDataSecurityIncidentLogRequest = KeyPaginationQueryParams & DynamicQueryParams;

export type GetDataSecurityIncidentLogResponse = PaginatedResource<DataSecurityIncident>;

export const getDataSecurityIncidentLog =
	createGetEndpoint<GetDataSecurityIncidentLogRequest, GetDataSecurityIncidentLogResponse>(
		(request) => `/api/v3/data-security/organization/incident-log?${getQueryString(request)}`
	);
